/**
 * DocTypePopover — small dropdown of canonical document types. Returns
 * the chosen type via `onPick`; closes on outside-click or ESC.
 */
import React, { useEffect, useRef } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { cn } from '@/lib/utils';

export const DOCUMENT_TYPES = [
  { id: 'nda',          label: 'اتفاقية سرية',     en: 'NDA' },
  { id: 'employment',   label: 'عقد عمل',          en: 'Employment Contract' },
  { id: 'partnership',  label: 'عقد شراكة',        en: 'Partnership Agreement' },
  { id: 'commercial',   label: 'عقد تجاري',        en: 'Commercial Contract' },
  { id: 'service',      label: 'اتفاقية خدمات',    en: 'Service Agreement' },
  { id: 'termination',  label: 'خطاب إنهاء',       en: 'Termination Letter' },
  { id: 'compliance',   label: 'مستند امتثال',     en: 'Compliance Document' },
  { id: 'policy',       label: 'سياسة داخلية',     en: 'Internal Policy' },
  { id: 'other',        label: 'نوع آخر',          en: 'Other' },
];

export function DocTypePopover({ onPick, onClose, isArabic }) {
  const ref = useRef(null);
  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose(); };
    const onEsc = (e) => { if (e.key === 'Escape') onClose(); };
    setTimeout(() => document.addEventListener('mousedown', onDoc), 10);
    document.addEventListener('keydown', onEsc);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onEsc);
    };
  }, [onClose]);

  return (
    <div
      ref={ref}
      className="absolute z-50 mt-1"
      style={{
        background: '#FFFFFF',
        border: '1px solid #E8E8E8',
        borderRadius: '8px',
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
        width: '220px',
        padding: '6px 0',
        ...(isArabic ? { right: 0 } : { left: 0 }),
      }}
      data-testid="doc-type-popover"
    >
      {DOCUMENT_TYPES.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => { onPick(t); onClose(); }}
          className={cn('w-full px-3.5 hover:bg-[#F5F5F5] font-arabic flex items-center', isArabic ? 'text-right' : 'text-left')}
          style={{ height: '36px', fontSize: '13px', color: '#111111', cursor: 'pointer' }}
          data-testid={`doc-type-${t.id}`}
        >
          {isArabic ? t.label : t.en}
        </button>
      ))}
    </div>
  );
}

export default DocTypePopover;
